export default {
    generateSubjectsKey: (courseId, termId)  => `${courseId}_${termId}`
}